import StatusComponent from "./components/StatusComponent";
import greenTick from "../../assets/images/greenTick.svg";
import overa from "../../assets/images/overa.svg";
import React from "react";

export function FrontBackMatch(props: {
  isValid?: boolean;
  isAdmin: boolean;
}) {
  if (!props.isAdmin) return <></>;

  const validationIcon =
    props.isValid == null ? "" : props.isValid ? greenTick : overa;
  const validationText =
    props.isValid == null ? "NA" : props.isValid ? "Yes" : "No";
  const validationTextStyle = props.isValid ? "green-stat" : "brown-stat";

  return (
    <div className="px-2">
      <StatusComponent
        blockStyle={""}
        label={"Front/back Match"}
        validationIcon={validationIcon}
        validationText={validationText}
        validationTextStyle={validationTextStyle}
      />
    </div>
  );
}
